/* tslint:disable */
/* eslint-disable */
/**
 * Trust Investigation API
 * The Law Society Trust Investigation Api with Swagger, Swashbuckle, and API Versioning.
 *
 * OpenAPI spec version: 2.0
 * Contact: hitesh.patel@lawsociety.com.au
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
import globalAxios, { AxiosPromise, AxiosInstance } from 'axios';
import { Configuration } from '../configuration';
// Some imports not used depending on template conditions
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError } from '../base';
import { BooleanResponse } from '../models';
import { EventRequest } from '../models';
import { EventRequest2 } from '../models';
import { EventViewIEnumerableResponse } from '../models';
import { PublicHolidayRequest } from '../models';
import { PublicHolidayViewIEnumerableResponse } from '../models';
import { PublicHolidayViewResponse } from '../models';
import { Request } from '../models';
/**
 * CalendarApi - axios parameter creator
 * @export
 */
export const CalendarApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary TA Admin | Returns Delete Public Holiday
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2CalendarDeletePublicHolidayIdDelete: async (id: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling apiV2CalendarDeletePublicHolidayIdDelete.');
            }
            const localVarPath = `/api/v2/Calendar/DeletePublicHoliday/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary TA ALL | Returns Events By TrustTeamMemberId
         * @param {EventRequest} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2CalendarGetEventsByTrustTeamMemberIdPost: async (body?: EventRequest, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v2/Calendar/GetEventsByTrustTeamMemberId`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required

            localVarHeaderParameter['Content-Type'] = 'application/json';

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof body !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(body !== undefined ? body : {}) : (body || "");

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary TA All | Returns Public Holiday by Id
         * @param {number} [id] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2CalendarGetPublicHolidayByIdGet: async (id?: number, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v2/Calendar/GetPublicHolidayById`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required

            if (id !== undefined) {
                localVarQueryParameter['id'] = id;
            }

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary TA ALL | Returns Public Holidays
         * @param {Request} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2CalendarGetPublicHolidaysPost: async (body?: Request, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v2/Calendar/GetPublicHolidays`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required

            localVarHeaderParameter['Content-Type'] = 'application/json';

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof body !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(body !== undefined ? body : {}) : (body || "");

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary TA Admin | Save Public Holiday
         * @param {PublicHolidayRequest} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2CalendarSavePublicHolidayPost: async (body?: PublicHolidayRequest, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v2/Calendar/SavePublicHoliday`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required

            localVarHeaderParameter['Content-Type'] = 'application/json';

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof body !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(body !== undefined ? body : {}) : (body || "");

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary TrustInvestigator | Returns Events By ExternalId
         * @param {EventRequest2} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2CalendarTrustInvestigatorGetEventsByExternalIdPost: async (body?: EventRequest2, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v2/Calendar/TrustInvestigator/GetEventsByExternalId`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required

            localVarHeaderParameter['Content-Type'] = 'application/json';

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof body !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(body !== undefined ? body : {}) : (body || "");

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary TA Admin | Update Nager Public Holidays | https://date.nager.at/Country
         * @param {string} [code] 
         * @param {number} [year] 
         * @param {Date} [start] 
         * @param {Date} [end] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2CalendarUpdatePublicHolidaysPut: async (code?: string, year?: number, start?: Date, end?: Date, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v2/Calendar/UpdatePublicHolidays`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required

            if (code !== undefined) {
                localVarQueryParameter['code'] = code;
            }

            if (year !== undefined) {
                localVarQueryParameter['year'] = year;
            }

            if (start !== undefined) {
                localVarQueryParameter['start'] = (start as any instanceof Date) ?
                    (start as any).toISOString() :
                    start;
            }

            if (end !== undefined) {
                localVarQueryParameter['end'] = (end as any instanceof Date) ?
                    (end as any).toISOString() :
                    end;
            }

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * CalendarApi - functional programming interface
 * @export
 */
export const CalendarApiFp = function(configuration?: Configuration) {
    return {
        /**
         * 
         * @summary TA Admin | Returns Delete Public Holiday
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV2CalendarDeletePublicHolidayIdDelete(id: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BooleanResponse>> {
            const localVarAxiosArgs = await CalendarApiAxiosParamCreator(configuration).apiV2CalendarDeletePublicHolidayIdDelete(id, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary TA ALL | Returns Events By TrustTeamMemberId
         * @param {EventRequest} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV2CalendarGetEventsByTrustTeamMemberIdPost(body?: EventRequest, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EventViewIEnumerableResponse>> {
            const localVarAxiosArgs = await CalendarApiAxiosParamCreator(configuration).apiV2CalendarGetEventsByTrustTeamMemberIdPost(body, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary TA All | Returns Public Holiday by Id
         * @param {number} [id] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV2CalendarGetPublicHolidayByIdGet(id?: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PublicHolidayViewResponse>> {
            const localVarAxiosArgs = await CalendarApiAxiosParamCreator(configuration).apiV2CalendarGetPublicHolidayByIdGet(id, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary TA ALL | Returns Public Holidays
         * @param {Request} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV2CalendarGetPublicHolidaysPost(body?: Request, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PublicHolidayViewIEnumerableResponse>> {
            const localVarAxiosArgs = await CalendarApiAxiosParamCreator(configuration).apiV2CalendarGetPublicHolidaysPost(body, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary TA Admin | Save Public Holiday
         * @param {PublicHolidayRequest} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV2CalendarSavePublicHolidayPost(body?: PublicHolidayRequest, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BooleanResponse>> {
            const localVarAxiosArgs = await CalendarApiAxiosParamCreator(configuration).apiV2CalendarSavePublicHolidayPost(body, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary TrustInvestigator | Returns Events By ExternalId
         * @param {EventRequest2} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV2CalendarTrustInvestigatorGetEventsByExternalIdPost(body?: EventRequest2, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EventViewIEnumerableResponse>> {
            const localVarAxiosArgs = await CalendarApiAxiosParamCreator(configuration).apiV2CalendarTrustInvestigatorGetEventsByExternalIdPost(body, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary TA Admin | Update Nager Public Holidays | https://date.nager.at/Country
         * @param {string} [code] 
         * @param {number} [year] 
         * @param {Date} [start] 
         * @param {Date} [end] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV2CalendarUpdatePublicHolidaysPut(code?: string, year?: number, start?: Date, end?: Date, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BooleanResponse>> {
            const localVarAxiosArgs = await CalendarApiAxiosParamCreator(configuration).apiV2CalendarUpdatePublicHolidaysPut(code, year, start, end, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
    }
};

/**
 * CalendarApi - factory interface
 * @export
 */
export const CalendarApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    return {
        /**
         * 
         * @summary TA Admin | Returns Delete Public Holiday
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2CalendarDeletePublicHolidayIdDelete(id: number, options?: any): AxiosPromise<BooleanResponse> {
            return CalendarApiFp(configuration).apiV2CalendarDeletePublicHolidayIdDelete(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary TA ALL | Returns Events By TrustTeamMemberId
         * @param {EventRequest} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2CalendarGetEventsByTrustTeamMemberIdPost(body?: EventRequest, options?: any): AxiosPromise<EventViewIEnumerableResponse> {
            return CalendarApiFp(configuration).apiV2CalendarGetEventsByTrustTeamMemberIdPost(body, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary TA All | Returns Public Holiday by Id
         * @param {number} [id] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2CalendarGetPublicHolidayByIdGet(id?: number, options?: any): AxiosPromise<PublicHolidayViewResponse> {
            return CalendarApiFp(configuration).apiV2CalendarGetPublicHolidayByIdGet(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary TA ALL | Returns Public Holidays
         * @param {Request} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2CalendarGetPublicHolidaysPost(body?: Request, options?: any): AxiosPromise<PublicHolidayViewIEnumerableResponse> {
            return CalendarApiFp(configuration).apiV2CalendarGetPublicHolidaysPost(body, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary TA Admin | Save Public Holiday
         * @param {PublicHolidayRequest} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2CalendarSavePublicHolidayPost(body?: PublicHolidayRequest, options?: any): AxiosPromise<BooleanResponse> {
            return CalendarApiFp(configuration).apiV2CalendarSavePublicHolidayPost(body, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary TrustInvestigator | Returns Events By ExternalId
         * @param {EventRequest2} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2CalendarTrustInvestigatorGetEventsByExternalIdPost(body?: EventRequest2, options?: any): AxiosPromise<EventViewIEnumerableResponse> {
            return CalendarApiFp(configuration).apiV2CalendarTrustInvestigatorGetEventsByExternalIdPost(body, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary TA Admin | Update Nager Public Holidays | https://date.nager.at/Country
         * @param {string} [code] 
         * @param {number} [year] 
         * @param {Date} [start] 
         * @param {Date} [end] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2CalendarUpdatePublicHolidaysPut(code?: string, year?: number, start?: Date, end?: Date, options?: any): AxiosPromise<BooleanResponse> {
            return CalendarApiFp(configuration).apiV2CalendarUpdatePublicHolidaysPut(code, year, start, end, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * CalendarApi - object-oriented interface
 * @export
 * @class CalendarApi
 * @extends {BaseAPI}
 */
export class CalendarApi extends BaseAPI {
    /**
     * 
     * @summary TA Admin | Returns Delete Public Holiday
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CalendarApi
     */
    public apiV2CalendarDeletePublicHolidayIdDelete(id: number, options?: any) {
        return CalendarApiFp(this.configuration).apiV2CalendarDeletePublicHolidayIdDelete(id, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * 
     * @summary TA ALL | Returns Events By TrustTeamMemberId
     * @param {EventRequest} [body] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CalendarApi
     */
    public apiV2CalendarGetEventsByTrustTeamMemberIdPost(body?: EventRequest, options?: any) {
        return CalendarApiFp(this.configuration).apiV2CalendarGetEventsByTrustTeamMemberIdPost(body, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * 
     * @summary TA All | Returns Public Holiday by Id
     * @param {number} [id] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CalendarApi
     */
    public apiV2CalendarGetPublicHolidayByIdGet(id?: number, options?: any) {
        return CalendarApiFp(this.configuration).apiV2CalendarGetPublicHolidayByIdGet(id, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * 
     * @summary TA ALL | Returns Public Holidays
     * @param {Request} [body] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CalendarApi
     */
    public apiV2CalendarGetPublicHolidaysPost(body?: Request, options?: any) {
        return CalendarApiFp(this.configuration).apiV2CalendarGetPublicHolidaysPost(body, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * 
     * @summary TA Admin | Save Public Holiday
     * @param {PublicHolidayRequest} [body] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CalendarApi
     */
    public apiV2CalendarSavePublicHolidayPost(body?: PublicHolidayRequest, options?: any) {
        return CalendarApiFp(this.configuration).apiV2CalendarSavePublicHolidayPost(body, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * 
     * @summary TrustInvestigator | Returns Events By ExternalId
     * @param {EventRequest2} [body] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CalendarApi
     */
    public apiV2CalendarTrustInvestigatorGetEventsByExternalIdPost(body?: EventRequest2, options?: any) {
        return CalendarApiFp(this.configuration).apiV2CalendarTrustInvestigatorGetEventsByExternalIdPost(body, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * 
     * @summary TA Admin | Update Nager Public Holidays | https://date.nager.at/Country
     * @param {string} [code] 
     * @param {number} [year] 
     * @param {Date} [start] 
     * @param {Date} [end] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CalendarApi
     */
    public apiV2CalendarUpdatePublicHolidaysPut(code?: string, year?: number, start?: Date, end?: Date, options?: any) {
        return CalendarApiFp(this.configuration).apiV2CalendarUpdatePublicHolidaysPut(code, year, start, end, options).then((request) => request(this.axios, this.basePath));
    }
}
